import React from "react";

const SpotifyIntegrationIcon = ({
  svgRef,
  ...props
}) => /*#__PURE__*/React.createElement("svg", Object.assign({
  width: 40,
  height: 40,
  viewBox: "0 0 40 40",
  fill: "none",
  ref: svgRef
}, props, {
  className: "transform-gpu " + (props.className || "")
}), /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0_2785_970)"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 20,
  cy: 20,
  r: 17,
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M31.8307 17.7304C25.3839 13.9018 14.7498 13.5498 8.59551 15.4177C7.60717 15.7176 6.56202 15.1595 6.26265 14.1715C5.9631 13.1825 6.52042 12.1381 7.50949 11.8376C14.5743 9.69323 26.3184 10.1074 33.7401 14.513C34.629 15.0408 34.9206 16.1888 34.3938 17.0762C33.8665 17.9651 32.7175 18.2582 31.8307 17.7304ZM31.6196 23.4011C31.1673 24.1351 30.2077 24.3653 29.4747 23.9146C24.0999 20.6108 15.9042 19.6537 9.54548 21.5839C8.72089 21.8331 7.84992 21.3681 7.59943 20.5451C7.35098 19.7205 7.81615 18.8511 8.63926 18.6004C15.9032 16.3961 24.9334 17.4638 31.1066 21.2574C31.8396 21.7088 32.0703 22.6689 31.6196 23.4011ZM29.1723 28.8471C28.8129 29.4365 28.0456 29.6212 27.4583 29.2619C22.7617 26.3915 16.8503 25.7433 9.88851 27.3334C9.21765 27.4872 8.54903 27.0668 8.39604 26.396C8.24238 25.7254 8.66118 25.0567 9.33353 24.9036C16.952 23.1619 23.4871 23.9115 28.7587 27.1328C29.3465 27.4918 29.5315 28.2596 29.1723 28.8471ZM20.0001 0C8.95449 0 0 8.9543 0 19.9997C0 31.0464 8.95449 40 20.0001 40C31.0459 40 40 31.0464 40 19.9997C40 8.9543 31.0459 0 20.0001 0Z",
  fill: "#1ED760"
})), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0_2785_970"
}, /*#__PURE__*/React.createElement("rect", {
  width: 40,
  height: 40,
  fill: "white"
}))));

const ForwardRef = React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SpotifyIntegrationIcon, Object.assign({
  svgRef: ref
}, props)));
export default ForwardRef;